import React from "react";
import { PageNewFrame } from "../Components/Page_New/PageNew";


export const NewPage = () => {

    return (
        <>
           <PageNewFrame></PageNewFrame>
        </>
    )
}
